module.exports = __webpack_public_path__ + "img/plus.dc308e64.svg";